"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Breadcrumb["default"];
  }
});

var _Breadcrumb = _interopRequireDefault(require("./Breadcrumb"));


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/collections/Breadcrumb/index.js
// module id = 7240
// module chunks = 0